import React from "react";

const SvgFullScreen = props => (
  <svg
    viewBox="0 0 512 512"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    {...props}
  >
    <path
      d="M73.143 329.143H0V512h182.857v-73.143H73.143V329.143zM0 182.857h73.143V73.143h109.714V0H0v182.857zm438.857 256H329.143V512H512V329.143h-73.143v109.714zM329.143 0v73.143h109.714v109.714H512V0H329.143z"
      fill="fill"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgFullScreen;
